import { PhoneNumberUtil } from "google-libphonenumber";
import * as yup from "yup";
const phoneUtil = PhoneNumberUtil.getInstance();

const comboboxValidation = yup.object({
  value: yup.string().uuid("Invalid Option").required("Value is required"),
  label: yup.string().required("Label is required"),
});

const arrayValidation = yup
  .array()
  .of(comboboxValidation.required("Item is required"));

const commonValidation = yup.object().shape({
  code: yup
    .string()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .nullable()
    .optional(),
  exim_code: yup
    .string()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .nullable()
    .optional(),
  short_code: yup
    .string()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .nullable()
    .optional(),
  company_name: yup
    .string()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .nullable()
    .optional(),
  vat_pan: yup
    .string()
    .nullable()
    .test("isNumber", "Invalid VAT/PAN number", (value) =>
      value === null || value === "" ? true : !isNaN(Number(value))
    ),
  delivery_charge_template: yup.string().nullable(),
  default_receiver: yup.string().nullable(),
  default_sender: yup.string().nullable(),
  default_service_type: yup.string().nullable(),
  default_product_type: yup.string().nullable(),
  default_payment_method: yup.string().nullable(),
  service_type: arrayValidation
    .min(0, "Please select a service type")
    .optional()
    .nullable(),
  product_type: arrayValidation
    .min(0, "Please select a product type")
    .optional()
    .nullable(),
  service_city: arrayValidation,
  service_branch: arrayValidation,
  payment_method: arrayValidation.optional().nullable(),
});

const createCustomerValidationForm = yup.object().shape({
  full_name: yup.string().required("Full Name is required"),
  address: yup.string().required("Address is required"),
  email: yup.string().email("Invalid Email Format").nullable(),
  primary_contact: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return true;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
  secondary_contact: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return true;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .optional()
    .nullable(),
  vat_pan: yup
    .string()
    .test("typeError", "Invalid VAT/PAN number", function (value) {
      return !isNaN(Number(value));
    })
    .nullable(),
});

const createUserValidationForm = commonValidation.shape({
  user: yup
    .mixed()
    .required("Please select a user")
    .test("is-valid-user", "Invalid user", (value) => {
      if (!value) return false;
      if (typeof value === "object" && "id" in value) return true;
      if (typeof value === "string" && value.trim() !== "") return true;
      return false;
    }),
  st_charge: yup
    .number()
    .typeError("ST Charge must be a number")
    .nullable()
    .notRequired(),
});

let createUserServiceValidationForm = yup.object().shape({
  username: yup
    .string()
    .required("Username is required")
    .min(3, "Username must be at least 3 characters")
    .max(20, "Username must be at most 20 characters")
    .matches(
      /^[a-zA-Z0-9_]+$/,
      "Username can only contain letters, numbers, and underscores"
    )
    .notOneOf(["admin", "root", "superuser"], "This username is not allowed"),
  full_name: yup.string().required("Full Name is required"),
  email: yup.string().email().required("Email is required"),
  mobile_number: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
  branch: yup.string().uuid().required("Please select a branch"),
});

const merchantDeliveryChargeTemplateValidationForm = commonValidation.shape({
  delivery_charge_template: yup
    .string()
    .required("Delivery Charge Tempate is required"),
  charge_type: yup
    .string()
    .oneOf(["flat", "percentage"])
    .required("Charge type is required"),
  charge: yup
    .string()
    .test(
      "typeError",
      "Invalid charge rate. Must be a number",
      function (value) {
        return !isNaN(Number(value));
      }
    )
    .when("charge_type", {
      is: (value: string) => value === "flat",
      then: (schema) =>
        schema.test("isPostive", "Charge rate must be positive", (value) => {
          return Number(value) >= 0;
        }),
      otherwise: (schema) =>
        schema
          .test("isPostive", "Charge rate must be positive", (value) => {
            return Number(value) >= 0;
          })
          .test(
            "isLessThan100",
            "Charge rate must be less than 100%",
            (value) => {
              return Number(value) <= 100;
            }
          )
          .required("Charge rate is required"),
    }),
  st_charge: yup
    .number()
    .typeError("ST Charge must be a number")
    .nullable()
    .notRequired(),
});
export const validateParty = yup.object({
  full_name: yup
    .string()
    .required("Supplier Name is required")
    .nonNullable("Supplier Name is required"),
  account: yup
    .string()
    .required("Account Type is required")
    .nonNullable("Account Type is required"),
  type: yup
    .string()
    .required("Type is required")
    .nonNullable("Type is required"),
  vat_pan: yup
    .string()
    // .required("Comapany (PAN/VAT) is required")
    // .nonNullable("Comapany (PAN/VAT) is required"),
    .optional()
    .nullable(),
  email: yup.string().email("Email is not valid").optional().nullable(),
  mobile_number: yup
    .string()
    .optional()
    .nullable()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value || value.trim() === "") return true;
      if (/^\+\d{1,4}$/.test(value.trim())) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    }),
});

export {
  createCustomerValidationForm,
  merchantDeliveryChargeTemplateValidationForm,
  createUserValidationForm,
  createUserServiceValidationForm,
};
